import React from 'react';
import { PropTypes } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import RadioButton from 'components/atoms/radioButton/index';

const QuestionOptions = ({ question, current, canEditPage }) => {
  const {
    ccmPatientDetails: { setAnswer },
  } = useDispatch();

  const answerGroups = useSelector((state) => state.ccmPatientDetails.answers);

  const selectedAnswerGuid = answerGroups[current][question.guid];

  return (
    <div className="question">
      <div className="question__question">
        <div className="question__question-text">{question.question}</div>
        {question.answers.map((answer, index) => (
          <RadioButton
            key={index}
            onChange={() =>
              setAnswer({
                questionGuid: [question.guid],
                answerGuid: answer.guid,
                group: current,
              })
            }
            id={answer.guid}
            name={question.guid}
            label={answer.answer}
            isChecked={selectedAnswerGuid === answer.guid}
            disabled={!canEditPage}
            canEditPage={canEditPage}
          />
        ))}
      </div>
    </div>
  );
};

QuestionOptions.propTypes = {
  question: PropTypes.object.isRequired,
  current: PropTypes.number.isRequired,
  canEditPage: PropTypes.bool,
};

export default QuestionOptions;
